import React from 'react';
import Dialog from 'components/pure/utils/Dialog';
import Loading from 'components/pure/utils/Loading';
import CallDeleteActions from 'actions/CallDeleteActions';
import Checkbox from 'material-ui/Checkbox';
import Button from '@material-ui/core/Button';
import 'styles/calls/CallDeleteDialog.styl';

/**
 * <CallCardDeleteDialog /> renders a modal material-ui Dialog to prompt the user to confirm whether
 * to delete a call or not
 */
class CallDeleteDialog extends React.PureComponent {
  render() {
    return (
      <Dialog
        className="delete-call"
        open={true}
        modal={true}
        autoScrollBodyContent={false}
        title="Delete Call?"
        onRequestClose={this.props.onRequestClose}>
        {this.props.isDeleteError ? (
          <div>
            <p className="delete-warning">We are sorry, there was an error deleting the call</p>
            <div className="button-row">
              <Button
                variant="contained"
                color="primary"
                className="cancel"
                onClick={this.props.onRequestClose}>
                OK
              </Button>
            </div>
          </div>
        ) : this.props.isDeleting ? (
          <Loading />
        ) : (
          <div>
            <p className="delete-warning">
              Are you sure you want to delete this call? Once deleted, a call is irretrievably lost,
              and cannot be retrieved. Any feedback on the call or metadata associated with it may
              also be lost.
            </p>
            <Checkbox
              className="confirm-delete"
              onCheck={() => CallDeleteActions.confirmToggle(!this.props.isConfirmed)}
              label={'Yes, I want this call to be irretrievably purged.'}
              checked={this.props.isConfirmed}
            />
            <div className="button-row">
              <Button variant="outlined" className="cancel" onClick={this.props.onRequestClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={this.props.isConfirmed ? 'delete' : 'delete-disabled'}
                onClick={() =>
                  this.props.isConfirmed && CallDeleteActions.deleteCall(this.props.callId)
                }
                disabled={!this.props.isConfirmed}>
                Confirm, Delete
              </Button>
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}

export default CallDeleteDialog;
